import { apiGet, apiPut } from "../client";
import type {
  SystemSettingsResponseApi,
  UpdateSystemSettingsRequestApi,
} from "../models/systemSettings";

export async function getSystemSettings(): Promise<SystemSettingsResponseApi> {
  return apiGet<SystemSettingsResponseApi>("system/settings");
}

export async function updateSystemSettings(
  request: UpdateSystemSettingsRequestApi,
): Promise<SystemSettingsResponseApi> {
  return apiPut<SystemSettingsResponseApi>("system/settings", request);
}
